import { render, staticRenderFns } from "./setindex.vue?vue&type=template&id=40a58188&scoped=true&"
import script from "./setindex.vue?vue&type=script&lang=js&"
export * from "./setindex.vue?vue&type=script&lang=js&"
import style0 from "./setindex.vue?vue&type=style&index=0&id=40a58188&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a58188",
  null
  
)

export default component.exports